import type { ProductCategory } from '../../shared/types';
import { PRODUCT_CATEGORY_OPTIONS } from '../../shared/types';

interface Props {
  value: ProductCategory;
  onChange: (value: ProductCategory) => void;
}

/**
 * Étape zéro de toute analyse : la qualification réglementaire du produit.
 * Le régime publicitaire applicable (visa GP, R5121-146, règlement (CE)
 * 1924/2006…) dépend d'abord de la catégorie — le sélecteur est donc affiché
 * sur tous les formulaires d'analyse, sauf question réglementaire et
 * Visaly Créa. Défaut : 'undecided' (audit prudentiel).
 */
export default function ProductCategorySelect({ value, onChange }: Props) {
  const selected = PRODUCT_CATEGORY_OPTIONS.find((o) => o.value === value);

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-slate-700 mb-2">
        Catégorie du produit
      </label>
      <div className="glow-input">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as ProductCategory)}
          className="w-full rounded-xl border border-slate-300 bg-cream-app px-4 py-2.5 text-sm text-slate-900 outline-none transition-shadow [&>option]:text-slate-900"
        >
          {PRODUCT_CATEGORY_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {selected && (
        <p className="mt-1.5 text-xs text-slate-500 leading-relaxed">
          {selected.description}
        </p>
      )}
    </div>
  );
}
